"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _icons = require("../../assets/icons");

var _DropdownButton = require("./DropdownButton.styles");

/* eslint-disable react/jsx-no-bind */
var DropdownButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      avatar = _ref.avatar,
      userName = _ref.userName,
      textBtn = _ref.textBtn,
      prefix = _ref.prefix,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      draggable = _ref.draggable,
      onBlur = _ref.onBlur;
  var prefixElement = (0, _react.useMemo)(function () {
    if (draggable) return (0, _jsxRuntime.jsx)(_icons.Grab, {
      className: "grui cursor-grabbing"
    });
    return prefix;
  }, [draggable, prefix]);
  return (0, _jsxRuntime.jsxs)(_Button["default"], {
    className: className,
    css: [_DropdownButton.styles.dropdownBtn, _DropdownButton.styles[size], textBtn && _DropdownButton.styles.textBtn, prefixElement && _DropdownButton.styles.withPrefix, process.env.NODE_ENV === "production" ? "" : ";label:DropdownButton;"],
    size: size,
    disabled: disabled,
    ref: ref,
    onClick: onClick,
    onBlur: onBlur,
    children: [prefixElement && (0, _jsxRuntime.jsx)("span", {
      css: _DropdownButton.styles.prefix,
      children: prefixElement
    }), avatar && (0, _jsxRuntime.jsx)(_Avatar["default"], {
      avatar: avatar,
      userName: userName,
      size: size
    }), children, (0, _jsxRuntime.jsx)("span", {
      css: _DropdownButton.styles.dropdownIcon,
      children: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
    })]
  });
});
DropdownButton.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  className: _propTypes.string,
  size: (0, _propTypes.oneOf)(['small', 'big']),
  avatar: _propTypes.string,
  userName: _propTypes.string,
  textBtn: _propTypes.bool,
  prefix: _propTypes.node,
  disabled: _propTypes.bool,
  onClick: _propTypes.func,
  onBlur: _propTypes.func,
  draggable: _propTypes.bool
};
DropdownButton.defaultProps = {
  className: undefined,
  size: 'big',
  avatar: undefined,
  userName: undefined,
  textBtn: false,
  prefix: undefined,
  disabled: false,
  onClick: function onClick() {},
  onBlur: function onBlur() {},
  draggable: false
};
DropdownButton.displayName = 'DropdownButton';
var _default = DropdownButton;
exports["default"] = _default;
//# sourceMappingURL=DropdownButton.js.map